import React, { useEffect, useState, useContext } from 'react'
import ReactModal from 'react-modal'
import { FormattedMessage } from 'react-intl'
import CloseIcon from 'assets/icons/close-icon'
import { CloseButton, CancelButton, ModalAutoSaveWrapper, ModalLabelContainer, StyledCloseButton } from './style'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import AutoSaveIcon from 'features/AutoSaveIcon'
import { useRequestQueue } from 'hooks/useRequestQueue'
import InfoHeader from 'components/InfoHeader'
import Button from 'components/Button'
import { requestGetSiteSpecie } from 'api/siteSpecie'
import NonQualifyWarningModal from './NonQualifyWarningModal'
import { SiteContext } from 'providers/site'
import ArrowLeftLine from 'assets/icons/arrow-left-line'


const customStyles = {
  content: {
    padding: '0',
    borderRadius: '8px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    pointerEvents: 'auto',
    transform: 'translate(-50%, -50%)'

  },
  overlay: {
    backgroundColor: 'transparent',
    pointerEvents: 'none',
    zIndex: 100001
  }
}

const customStylesComments = {
  content: {
    padding: '0',
    top: '0',
    left: 'auto',
    right: '0',
    bottom: 'auto',
    marginLeft: '-50%',
    pointerEvents: 'auto'
  },
  overlay: {
    backgroundColor: 'transparent',
    pointerEvents: 'none',
    zIndex: 1000
  }
}

const tooltipXOffset = 0
const tooltipYOffset = 16

const Modal = ({
  children,
  isOpen,
  toggleModal,
  toggleModal1,
  modalTitleId,
  infoTooltip,
  zIndex,
  infoHeader,
  paddingBottom,
  paddingTop,
  marginLeft,
  justifyContent,
  label,
  width = '416px',
  bottomBorder = true,
  padding = '32px',
  height = '',
  bigModal = false,
  sideModal = false,
  titleValue,
  assessmentValue,
  cancelTitleButton = 'cancel',
  autoSaveIcon = false,
  isDraft = false,
  cancelHandler,
  bigModalTittle = cancelHandler ? 'reassess' : 'finishEditing',
  speciesToReassess,
  marginTop='0px',
  closeButton=false,
}) => {
  const isLoading = useRequestQueue()
  const [taxonTreatment, setTaxonTreatment] = useState('')
  const [showWarning, setShowWarning] = useState(false)

  const { triggerReasonId } = useContext(SiteContext)

  useEffect(() => {
    if (speciesToReassess && speciesToReassess) {
      requestGetSiteSpecie(speciesToReassess.id, speciesToReassess.SiteHistoryId, speciesToReassess.historyId).then(
        (data) => {
          setTaxonTreatment(data.taxonTreatment)
        }
      )
    }
  }, [speciesToReassess])

  const handleReassessClicked = () => {
    const warningCategories = ['A-NR', 'Q-NR', 'S-NR', 'U-NR', 'U-UR', 'A-UR']

    // eslint-disable-next-line no-magic-numbers
    if (warningCategories.includes(taxonTreatment) && triggerReasonId.includes(1)) {
      setShowWarning(true)
    } else {
      if (toggleModal1) {
        toggleModal1(true) // ✅ Use toggleModal1 if available
      } else {
        toggleModal(true)
      }
    }
  }

  const handleFinishEditingClicked = () => {
    if (toggleModal1) {
      return toggleModal1(false) // ✅ Use toggleModal1 if available
    }
    return toggleModal(false)
  }

  return (
    <div data-testid="test-react-modal">
      <ReactModal
        isOpen={isOpen}
        style={{
          ...(bigModal
            ? { ...customStyles, content: { ...customStyles.content, height: '90vh', overflowY: 'scroll', marginTop } }
            : sideModal
              ? customStylesComments
              : customStyles),
          overlay: {
            ...(sideModal ? customStylesComments : customStyles),
            zIndex: zIndex || 1000
          }
        }}
        shouldCloseOnOverlayClick={true}
      >
        <div style={{ width }}>
          <div style={{ position: 'relative' }}>
            <div style={bigModal ? { position: 'sticky', top: '0px', zIndex: '1000', background: 'white' } : {}}>
              {autoSaveIcon && (
                <ModalAutoSaveWrapper>
                  <AutoSaveIcon loading={isLoading} time={'saved'} />
                </ModalAutoSaveWrapper>
              )}
              <CloseButton
                data-testid="test-close-button-modal"
                data-test="close-button"
                bigModal={bigModal}
                onClick={cancelHandler ? handleReassessClicked : handleFinishEditingClicked}
              >
                {bigModal && isDraft ? (
                  <StyledCloseButton>
                    <FormattedMessage id={bigModalTittle} />
                  </StyledCloseButton>
                ) : (
                  closeButton ? <Button height="40px" marginTop='0'>
                    <ArrowLeftLine />
                    <FormattedMessage id="backToSelection" />
                  </Button>:
                  <CloseIcon />
                )}
              </CloseButton>

                  {/* <Button height="40px" withIcon={true}>
                    <ArrowLeftLine />
                    <FormattedMessage id="backToSelection" />
                  </Button> */}

              {cancelHandler && (
                <CancelButton>
                  <Button type="secondary" height="40px" marginTop="0" onClick={cancelHandler}>
                    <FormattedMessage id={cancelTitleButton} />
                  </Button>
                </CancelButton>
              )}

              <ModalLabelContainer
                data-test="modal-label"
                bottomBorder={bottomBorder}
                paddingBottom={paddingBottom}
                paddingTop={paddingTop}
                paddingRight={'32px'}
                marginLeft={marginLeft}
                justifyContent={justifyContent}
              >
                {titleValue ? (
                  <FormattedMessage id={modalTitleId} values={{ commentNumber: <>{`(${titleValue})`}</> }} />
                ) : assessmentValue ? (
                  <FormattedMessage id={modalTitleId} values={{ assessmentsNumber: <>{`(${assessmentValue})`}</> }} />
                ) : (
                  <FormattedMessage id={modalTitleId} />
                )}
                {infoHeader && <InfoHeader text={infoHeader}></InfoHeader>}
                {infoTooltip && (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    zIndex={zIndex}
                    placement="bottom"
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: label, infoTooltip: infoTooltip }}
                  >
                    <div>
                      <InfoIcon />
                    </div>
                  </Tooltip>
                )}
              </ModalLabelContainer>
            </div>
            <div style={{ padding: padding, height: height }}>{children}</div>
          </div>
        </div>
      </ReactModal>
      {showWarning && <NonQualifyWarningModal isOpen={showWarning} toggleModal={setShowWarning} />}
    </div>
  )
}

export default Modal
